<ion-card-header>
    More leases
</ion-card-header>
<ion-card-content>
    <ion-list>
        <previous-lease-item *ngFor="let lease of previousLeases"
                             [lease]="lease"
                             (click)="viewLease(lease)"></previous-lease-item>
    </ion-list>
</ion-card-content>